import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../core/services/environment.service';
import { JsonResult } from '../core/json-result.model';
import { EmailResponseValidateModel } from '../core/models/email-response-validate.model';

@Injectable({
  providedIn: 'root'
})
export class EmailValidatorService {
  usernameValidatorService: string;
  passwordValidatorService: string;
  urlValidatorService: string;
  constructor(private httpClient: HttpClient,
    handler: HttpBackend,
    private environmentService: EnvironmentService) {
    this.httpClient = new HttpClient(handler);
  }
  emailValidate(email: any): Observable<any> {
    /*
       this.urlValidatorService = this.environmentService.urlValidatorService;
      let body= {to : email};
*/
    //
    //const httpOptions =
    //   {
    //   headers: new HttpHeaders({
    //    "Accept": "*/*",
    //  "Content-Type": "application/json",
    // "Authorization": "Basic " + btoa(this.usernameValidatorService + ':' + this.passwordValidatorService),
    // }),
    // };  

    //return this.httpClient.post<any>(this.urlValidatorService, body, httpOptions);
    //return this.httpClient.post<JsonResult<EmailValidatorResponse[]>>(url, { headers }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
    let url = `${this.environmentService.virtualOfficeServiceUrl}EmailSetting/ValidateEmail`;
    return this.httpClient.post<EmailResponseValidateModel>(url, { to: email });
  }

  emailValidateV2(email: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}/EmailSetting/ValidateEmail`;
    return this.httpClient.post<EmailResponseValidateModel>(url, { to: email });

  }

}